import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User } from '$src/types';

export interface AppState {
  user: Partial<User>;
  count: number;
  showLoginModal: boolean;
}

const initialState: AppState = {
  user: {},
  count: 0,
  showLoginModal: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<Partial<User>>) => {
      state.user = { ...action.payload };
    },
    increase: (state, action: PayloadAction<number>) => {
      state.count += action.payload;
    },
    decrease: (state, action: PayloadAction<number>) => {
      state.count -= action.payload;
    },
    showLoginModal: (state) => {
      state.showLoginModal = true;
    },
    hideLoginModal: (state) => {
      state.showLoginModal = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, increase, decrease, showLoginModal, hideLoginModal } = appSlice.actions;

export const appReducer = appSlice.reducer;
